export const getAuthHeaderAndShopperId = (auth: any)  => {
  return {
    authHeader: auth.getAuthorizationHeader(),
    shopperId:
      auth.isSignedIn() &&
      auth.getProfile()['https://claims.cimpress.io/canonical_id'],
  };
};
